import {
    WHISHLIST,
    WHISHLIST_SUCCESS,
    WHISHLIST_FAILURE,
} from '../actions/action-types';

/**
 * initial state
 */
const INIT_STATE = {
    data: null,
    error: null,
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case WHISHLIST:
            return { ...state, loading: true };

        case WHISHLIST_SUCCESS:
            return { ...state, loading: false, data: action.payload };

        case WHISHLIST_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default: return { ...state };
    }
}
